/**
 * Serves a module, which can be started separately to require the user login
 */

import SetVersionDocumentTitle from 'gw-portals-platform-angular/versionName/SetVersionDocumentTitle';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures'; // PSA

// VARS

// ui-view vars
const uiViewAttr = 'ui-view';
const uiViewHtml = `<div ${uiViewAttr}></div>`;
const $initialUiView = $(document.body).children(`[${uiViewAttr}]`);
const repairerAppPSA = !ApplicationFeatures.hasFeature('role.producer') && ApplicationFeatures.hasFeature('role.vendor'); // PSA

// initial hash logic
const initialHash = window.location.hash;

// METHODS
/**
 * Restores the exact URL hash, which the user might have
 * before starting to interact with the auth app
 */
function restoreInitialHash() {
    if (!initialHash) {
        return;
    }
    window.location.hash = initialHash;// restore an initial hash
}

// user info logic
/**
 * Updates the user info to be used in the Portal app
 * @param {Object} UserInfoService
 * @param {String} userType
 * @param {String} publicId
 */
function updateUserInfo(UserInfoService, userType, publicId, user) {
    UserInfoService.setUserInfo({
        userType
    });
    
    UserInfoService.setUserPublicId(publicId);
    //UCEPRODENG-746, 776 Phone Number valid format
    window.PSAUSER = user;
    UserInfoService.setUser(user);
}

// applications interaction logic
/**
 * Destroys the auth app
 * @param {Object} $rootScope
 */
function destroyAuthApp($rootScope) {
    // Destroy the auth app
    $rootScope.$destroy(); // Destroy the scope tree
    $(document.body).children(`[${uiViewAttr}]`).remove(); // Remove node from the DOM. Also wipes related data stored on the node.
}

/**
 * Triggers usual Portal app loading
 * @param {Function} loadPortal
 */
function triggerPortalLoad(loadPortal) {
    $(document.body).append(uiViewHtml);// include required ui-view
    loadPortal();// trigger the usual Portal app
}

function redirectToPSA(page) {
    const urlWithoutHash = window.location.href.split('#')[0];
    const newUrlPrefix = urlWithoutHash.substring(0, urlWithoutHash.lastIndexOf('/') + 1).concat();
    window.location.href = `${newUrlPrefix}${page}`;
}

function loadAppPSA($rootScope, loadPortal, UserInfoService, user) {
    updateUserInfo(UserInfoService, user.userType, user.publicID, user);

    destroyAuthApp($rootScope);

    restoreInitialHash();
    triggerPortalLoad(loadPortal);
}

/**
 * @param {Function} loadPortal function to trigger the usual Portal loading
 */
export default (loadPortal) => {
    const initialAppName = 'initialauthapp'; // custom unique name

    angular.module(
        initialAppName,
        ['edge.platform.auth']// depends on and triggers the auth module
    )
        .run(['$rootScope', 'gwAuthTokenService', '$q', 'UserInfoService', 'TransportService', '$translate',
            ($rootScope, AuthTokenService, $q, UserInfoService, TransportService, $translate) => {
                SetVersionDocumentTitle({
                    $translate,
                    // "portal.app.versionName.title[.${VERSION}]" l10n ID (with a version, if available for the app) will be used
                    translationIdBase: 'portal.app.versionName.title'
                });

                $q.when(AuthTokenService.accessTokenDecoded) // once user is logged in
                    .then(() => {

                        // PSA: if 'vendors' version is loaded, go to CC for the user info
                        let appPSA = 'pc';
                        if (repairerAppPSA) {
                            appPSA = 'cc';
                        }

                        // PSA: complex logic
                        // if User is NOT in PC, login is redirected to CC (index-vendors.html)
                        // if User is in PC, it must be in CC too. If any of PC or CC user fails, login fails
                        // if User is in CC, PC is NOT verified
                        TransportService.send(appPSA, 'gateway/user', 'getCurrentUser', [])// get the user data
                            .then((user) => {
                                // PSA: user is in PC, it must be in CC too
                                if (appPSA === 'pc') {
                                    // PSA: PC User exists, now verify CC user ...
                                    TransportService.send('cc', 'gateway/user', 'getCurrentUser', [])// get the user data
                                        .then(() => {
                                            // PSA: and PC and CC user exist, load the app
                                            loadAppPSA($rootScope, loadPortal, UserInfoService, user); // note: still user PC user, it has more info!
                                        }).catch((err) => {
                                            // PSA: PC user exists, but not CC user, show error
                                            //UCWPRODENG-875
                                            window.isPCUser =  true;
                                            console.error('Couldn\'t get the user data:', err);
                                            redirectToPSA('psa-login-error.html');
                                        });
                                } else {
                                    // PSA: url for repairer and CC User exists, load the app
                                    loadAppPSA($rootScope, loadPortal, UserInfoService, user);
                                }
                            })
                            .catch((err) => {
                                if (appPSA === 'pc') {
                                    // PSA: url for seller, but PC user does not exist. most likely user is RepairerOnly, redirecting ...
                                    console.warn('Redirecting to index-vendors.html');
                                    redirectToPSA('index-vendors.html');
                                } else {
                                    // PSA: url for repairer, but CC user does not exist, show error
                                    console.error('Couldn\'t get the user data:', err);
                                    redirectToPSA('psa-login-error.html');
                                }
                            });

                    });

            }]);

    angular.bootstrap($initialUiView, [initialAppName]);// initiate the auth app
};
